<template>
<v-form v-model="valid">
    <v-container>
        <v-row>
            <v-col cols="12" md="12">
                <h1>Center Administration</h1>
                <v-btn :disabled="!valid" color="success" class="mr-4" @click="save">Gem</v-btn>
            </v-col>
        </v-row>

        <v-snackbar v-model="showSnackbar" :multi-line="false" :timeout="5000" dark color="#EE765E" class="title">
            {{ snackbarText }}
            <v-btn color="white" text @click="showSnackbar = false">Luk</v-btn>
        </v-snackbar>
    </v-container>
</v-form>
</template>

<script>
// import {    EventBus} from './../../event-bus.js';

import store from "./../../store";
import core from './../../mixins/core';

export default {

      data: function () {
        return {

    
        showSnackbar: false,
        snackbarText: "",
        valid: false,
        user: {
            email: "",
            firstName: "",
            lastName: "",
        },
        nameRules: [
            //   v => !!v || 'Name is required',
            //   v => v.length <= 10 || 'Name must be less than 10 characters',
        ],
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
    }},
    mixins: [core],
    mounted() {
        this.user = store.getters.currentUser;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === "setUser") {
                this.user = state.currentUser;
                if (state.currentUser.firstName == null) {
                    this.fillOutName();
                }

            }
        });

        if (this.$route.params.fillOutName) {
            this.fillOutName();
        }

        //  EventBus.$on('fillOutName', this.fillOutName);
        //        this.user.email = "123";
        //         console.log(this.user.email);
    },
    methods: {
        fillOutName() {
            this.showSnackbar = true;
            this.snackbarText = "Din profil mangler at få udfyldt dit navn";
        },
        save() {
            this.addUpdateUser(this.user).then((user) => {
                store.commit('setUser', user);
                this.showSnackbar = true;
                this.snackbarText = "Profil gemt";

            });
        },
    },
    name: "CenterAdmin",
};
</script>
